/* Shopix Hub - lightweight behaviour (no dependencies). This file does not touch any buy button (COD / prepaid). */
(() => {
  if (window.__sxLoaded) return;
  window.__sxLoaded = true;
  const rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('sx-in'); io.unobserve(e.target); } }), { threshold: 0.1 }) : null;

  function initVideo(v) {
    if (v.dataset.sxInit) return;
    v.dataset.sxInit = '1';
    v.muted = true;
    v.setAttribute('playsinline', '');
    const wrap = v.closest('.sx-media');
    const fail = () => wrap && wrap.classList.add('sx-media--fallback');
    v.addEventListener('error', fail, true);
    if (rm.matches || !('IntersectionObserver' in window)) { v.pause(); v.removeAttribute('autoplay'); return; }
    const vio = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { const p = v.play(); if (p && p.catch) p.catch(fail); } else { v.pause(); }
    }), { threshold: 0.25 });
    vio.observe(v);
  }

  function initGif(img) {
    if (rm.matches && img.dataset.still) img.src = img.dataset.still;
  }

  function initTrio(el) {
    if (el.dataset.sxT || el.dataset.rotate !== 'true' || rm.matches) return;
    const cards = Array.from(el.querySelectorAll('.sx-trio__card'));
    if (cards.length < 2) return;
    el.dataset.sxT = '1';
    let i = 0;
    const tick = () => {
      if (document.hidden) return;
      cards.forEach((c, k) => c.classList.toggle('is-lit', k === i));
      i = (i + 1) % cards.length;
    };
    tick();
    setInterval(tick, 3200);
  }

  function init(root) {
    root = root || document;
    if (io) root.querySelectorAll('.sx-reveal').forEach((el) => io.observe(el));
    root.querySelectorAll('video[data-sx-video]').forEach(initVideo);
    root.querySelectorAll('img[data-sx-gif]').forEach(initGif);
    root.querySelectorAll('[data-sx-trio]').forEach(initTrio);
  }

  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
